import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.css']
})
export class PlaceholderComponent implements OnInit {
  @Input() width;
  @Input() height;
  @Input() circle;
  @Input() paddingTop;

  constructor() { }

  ngOnInit() {
  }

}
